



















































































import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';
import SelectBox from '@/components/util/SelectBox.vue';
import {getAddressData} from '@/api/util/zipcloud';

// 都道府県リスト
const PREF_LIST = NOC.PREFECTURE.getOptions();

export default Vue.extend({
  name: 'Confirm',
  components: {
    VariableInput,
    SelectBox,
  },
  props: {
    isProcessing: Boolean, // 2重サブミット防止
  },
  data() {
    return {
      editData: new models.CNewAccount(),
      items: [
        {
          key: 'name',
          name: '氏名',
          contents: {
            lastName: { key: 'sei', name: '姓', type: vi.INPUT_TYPE.TEXT, placeholder: '姓', class: '', required: true, error: '', max: 40 },
            firstName: { key: 'mei', name: '名', type: vi.INPUT_TYPE.TEXT, placeholder: '名', class: '', required: true, error: '', max: 40 },
          },
          required: true,
        },
        {
          key: 'nameKana',
          name: 'フリガナ',
          contents: {
            lastName: { key: 'seiKana', name: 'セイ', type: vi.INPUT_TYPE.TEXT, placeholder: 'セイ', class: '', required: true, checks: [vi.CHECK_TYPE.KANA], error: '', max: 40 },
            firstName: { key: 'meiKana', name: 'メイ', type: vi.INPUT_TYPE.TEXT, placeholder: 'メイ', class: '', required: true, checks: [vi.CHECK_TYPE.KANA], error: '', max: 40 },
          },
          required: true,
        },
        { key: 'companyName', name: '会社名', type: vi.INPUT_TYPE.TEXT, placeholder: '会社名', class: '', required: true, checks: [], error: '', max: 100 },
        { key: 'branchName', name: '支店名', type: vi.INPUT_TYPE.TEXT, placeholder: '支店名', class: '', required: false, checks: [], error: '', max: 100 },
        { key: 'postalCode', name: '郵便番号', type: vi.INPUT_TYPE.TEXT, placeholder: '150-0001', class: 'half-column postcode', required: true, checks: [vi.CHECK_TYPE.POSTAL_CODE], error: '', min: 7, max: 8 },
        { key: 'prefCode', name: '都道府県', type: vi.INPUT_TYPE.SELECT, placeholder: '選択してください', class: '', required: true, error: '' },
        { key: 'address', name: '市区町村・番地', type: vi.INPUT_TYPE.TEXT, placeholder: '市区町村・番地', class: '', required: true, checks: [], error: '', max: 100 },
        { key: 'building', name: '建物名', type: vi.INPUT_TYPE.TEXT, placeholder: '建物名', class: '', required: false, checks: [], error: '', max: 60 },
        { key: 'tel', name: '電話番号', type: vi.INPUT_TYPE.TEXT, placeholder: '電話番号', class: '', required: true, checks: [vi.CHECK_TYPE.TEL], error: '', min: 10, max: 20 },
      ] as vi.IVariableInput[],
      prefecturesList: PREF_LIST,
    };
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  created() {
    if (process.env.VUE_APP_MODE === 'PROD') {
      (this as any).$gtm.trackView( location.pathname.toString() , location.toString());
    }
    this.prefecturesList[0].text = '選択してください';
  },
  methods: {
    onInputItem(key: string, value: any) {
      if (key === 'prefCode') {
        this.checkPrefCode(value);
      }
    },
    onClickRegist() {
      // vallidation check
      let errorNum = vi.checkValues(this.editData, this.toCheckItemList(this.items));
      errorNum += this.checkPrefCode(this.editData.prefCode); // 都道府県の必須チェック
      if (errorNum) {
        return;
      }
      // emit confirm
      this.$emit('confirm', this.editData);
    },
    async onClickAutoAddress() {
      // 住所自動入力

      // 入力チェック
      const postalItem = this.items.find((v) => v.key === 'postalCode');
      if (!postalItem || vi.checkValue(this.editData.postalCode, postalItem)) {
        return;
      }
      // 住所情報を取得
      const zipResult = await getAddressData(this.editData.postalCode);
      if (zipResult.success && zipResult.results) {
        const result = zipResult.results[0];
        this.editData.prefCode = Number(result.prefcode);
        this.editData.address = result.address2 + result.address3;
        this.editData.building = '';
        // 入力エラーをリセット
        const items = this.items.filter((v) => v.key === 'address' || v.key === 'building');
        for (const item of items) {
          item.error = '';
        }
      } else {
        console.log(zipResult.message);
      }
    },
    checkPrefCode(prefCode: number): number {
      // 都道府県が「未選択」の場合は必須エラー
      const prefItem = this.items.find((v) => v.key === 'prefCode');
      if (!prefItem) {
        return 0;
      }
      const isError = prefCode === NOC.SELECT.NOSELECT.value;
      prefItem.error = isError ? '必須項目です。' : '';
      return Number(isError);
    },
    changePrefCode(prefCode: number) {
      this.editData.prefCode = prefCode;
    },
    toCheckItemList(items: any[]) {
      const checkItemList = [] as any[];
      items.forEach((v) => {
        if (v.contents) {
          Object.keys(v.contents).forEach((key) => {
            checkItemList.push(v.contents[key]);
          });
        } else {
          checkItemList.push(v);
        }
      });
      return checkItemList;
    },
  },
});
